module.exports = __webpack_public_path__ + "static/media/od_8.c47640d1.jpg";